/* eslint-disable no-case-declarations */
import { Injectable } from "@angular/core";
import { tap, finalize } from "rxjs/operators";
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { from } from "rxjs";
import { ErrorDialogComponent } from "../@evo/components/error-message-dialog/error-message-dialog.component";
import { MatDialog } from "@angular/material";
import { LoaderService } from "./configuration/loader-service";
import { APIConfigService } from './configuration/api.config';
import { SpecialService } from './configuration/special.service';
import { GlobalCurrentUserService } from './pages/Services/global-current-user.service';
import { API } from './configuration/end-points';
import { Router } from '@angular/router';
import { SharedService } from './pages/Services/shared.service'
import { CookieService } from "ngx-cookie-service";
import { secureStorage } from './pages/Services/secure-storage';


@Injectable()
export class MyInterceptor implements HttpInterceptor {
  basicApiHost: any;
  dialogRef: any;
  historyURL: any;
  flag = true;
  apiEndpointURL: string;
  apiHost: any;

  constructor(private dialog: MatDialog,
    public loaderService: LoaderService,
    private aPIConfigService: APIConfigService,
    private specialService: SpecialService,
    private globalCurrentUserService: GlobalCurrentUserService,
    private router: Router,
    private sharedServices: SharedService,
    private cookieService: CookieService) {
    this.sharedServices.getConfig().subscribe(result => {
      if (result) {
        this.basicApiHost = result["basicApiHost"];
        this.apiHost = result["apiHost"];
      }
    })
    localStorage.setItem("temp", "temp");

  }

  //function which will be called for all http calls
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ) {

    
    this.loaderService.show();
    
    //console.log("request===>",this.apiHost + "/" + API.WORKFLOW.Listing, this.apiEndpointURL);
    return from(this.handle(request, next)).pipe(
      tap(
        (event) => {
          //logging the http response to browser's console in case of a success
          if (event instanceof HttpResponse) {
            // console.log("api call success :", event);
            this.loaderService.hide();
          }
        },
        (error) => {
          this.loaderService.hide();
          const errorMsg = [];
          switch (error.status) {
            case 404:
              if (error.url.match(/refreshToken/g)) {
                localStorage.clear();
                this.cookieService.deleteAll('/', null, true);
                this.flag = true;
                this.router.navigate(["/login"]);
                this.globalCurrentUserService.checkLoggedIn.next(false);
                break;
              }
            case 400:
              this.loaderService.hide();
              if (error.error && error.error.errors) {
                const errors = error.error.errors;
                for (const [key, value] of Object.entries(errors)) {
                  const element: any = value;
                  const str = key + "- " + element.join();
                  errorMsg.push(str);
                }
              } else if (error.error.message) {
                errorMsg.push(error.error["message"]);
              } else if (error.error.Message) {
                errorMsg.push(error.error["Message"]);
              } else {
                errorMsg.push("Bad request");
              }
              break;
            case 422:
              this.loaderService.hide();
              // eslint-disable-next-line no-empty
              if (!error.url.match(/downloadlogo/g)) {
                errorMsg.push(
                  error.error.title ||
                  error.error.message ||
                  error.error.Message ||
                  error.error.error_description ||
                  JSON.parse(error.error)['message'] ||
                  "Internal Server Error"
                );
              }
              break;
            case 401:
              this.loaderService.hide();
              if (error.error && error.error.error_description) {
                errorMsg.push(error.error.error_description);
              }
              const updatedURL: any = error.url;
              const tempURIPartUpdated = updatedURL.split("/")
              const keyFromUpdated = tempURIPartUpdated[tempURIPartUpdated.length - 1];
              if (error.error.message) {
                errorMsg.push(error.error["message"]);
              }
              // if(keyFromUpdated==="refreshToken"){
              //   window.localStorage.clear();
              //   this.router.navigate(["/login"]);
              // }
              this.historyURL = localStorage.getItem("temp");
              if (this.historyURL) {
                window.localStorage.clear();
                this.cookieService.deleteAll('/', null, true);
                //this.flag= true;
                const redirectTo = (location.pathname+location.search).substr(1)
                this.router.navigate(["/login"], { queryParams: { redirectTo: redirectTo } });
                this.globalCurrentUserService.checkLoggedIn.next(false);
                if (this.dialogRef) return;
                if(error.error["error"] != "invalid_token"){
                  this.dialogRef = this.dialog.open(ErrorDialogComponent, {
                    width: "400px",
                    data: errorMsg,
                  });
                  this.dialogRef.afterClosed().subscribe((result) => {
                    this.dialogRef = false;
                    localStorage.setItem("temp", null);
                  });
                }
              }
              break;
            case 500:
              if (error.error && error.error.error_description) {
                !(error.url.match(/addmissingsentences/g) || error.url.match(/tasks/g)) && errorMsg.push(error.error.error_description);
              } else {
                !(error.url.match(/addmissingsentences/g) || error.url.match(/tasks/g)) && errorMsg.push("Internal Server Error.");
              }
              break;
            default:
              if (error.error && error.error.error_description) {
                !(error.url.match(/addmissingsentences/g) || error.url.match(/tasks/g)) && errorMsg.push(error.error.error_description);
              }
              break;
          }
          this.loaderService.hide();
          if (error.status == 401) {
            return;
          }
          if (error.status != 200) {            
            if (this.dialogRef) return;
            if(error.status == 422 && error.url.match(/provider/g) && error.url.match(/agreement/g)){
              return;
            } else {
              if (errorMsg.length) {
                this.dialogRef = this.dialog.open(ErrorDialogComponent, {
                  width: "400px",
                  data: errorMsg,
                });
                this.dialogRef.afterClosed().subscribe((result) => { this.dialogRef = false });
              }
            }
          }

          //logging the http response to browser's console in case of a failuer
          // console.log("api call error :", error);
        }
      ),
      finalize(() => this.loaderService.hide())
    )    //how to update the request Parameters

    //   this.loaderService.show();
    //   let temp:any;
    //   //logging the updated Parameters to browser's console
    //   return next.handle(request).pipe(
    //     tap(
    //       (event) => {
    //         //logging the http response to browser's console in case of a success
    //         if (event instanceof HttpResponse) {
    //           // console.log("api call success :", event);
    //           this.loaderService.hide();
    //         }
    //       },
    //       (error) => {
    //         let errorMsg = [];
    //         switch (error.status) {
    //           case 400:
    //             if (error.error && error.error.errors) {
    //               let errors = error.error.errors;
    //               for (const [key, value] of Object.entries(errors)) {
    //                 let element: any = value;
    //                 let str = key + "- " + element.join();
    //                 errorMsg.push(str);
    //               }
    //             }
    //             break;
    //           case 422:
    //             errorMsg.push(
    //               error.error.title ||
    //                 error.error.message ||
    //                 "Internal Server Error"
    //             );
    //             break;
    //           case 401:
    //             errorMsg.push("You are not authorized to access this content.");
    //             break;
    //           case 500:
    //             errorMsg.push("Internal Server Error.");
    //             break;
    //         }
    //         // this.loaderService.hide();
    //         if (error.status != 200) {
    //           const dialogRef = this.dialog.open(ErrorDialogComponent, {
    //             width: "400px",
    //             data: errorMsg,
    //           });
    //           dialogRef.afterClosed().subscribe((result) => {});
    //         }

    //         //logging the http response to browser's console in case of a failuer
    //         // console.log("api call error :", error);
    //       }
    //     ),
    //     finalize(() => this.loaderService.hide())
    //   );
    // }
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    const apiUrl = req.url;
    const endpoint = apiUrl.replace(this.basicApiHost, '');
    this.apiEndpointURL = endpoint;
    let authReq = req;
    // if your getAuthToken() function declared as "async getAuthToken() {}"
    // let accessToken = JSON.parse(localStorage.getItem("currentUser"));
    let accessToken;
    const encr = secureStorage.hash("currentUser");
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    !this.cookieService.check(encr) && (accessToken = null);

    const res = apiUrl.match(/login/g);
    if (accessToken != null && res === null) {

      const MS_PER_MINUTE = 60000;

      const expiresIn = new Date(accessToken.expiresIn);
      const currentDate = new Date();
      // expiresIn = new Date(expiresIn - 2 * MS_PER_MINUTE);
      // console.log(expiresIn);
      // console.log("currentDate > expiresIn && endpoint != '/'+API.REFRESH_TOKEN.REFRESH");
      //console.log(currentDate > expiresIn && endpoint != '/'+API.REFRESH_TOKEN.REFRESH);

      if (currentDate > expiresIn &&
        endpoint != '/' + API.REFRESH_TOKEN.REFRESH &&
        !endpoint.match(/\/assets\/json\/config/g)) {
        this.flag = false;
        let temp: any;
        const response = await this.specialService.refreshToken(temp, API.REFRESH_TOKEN.REFRESH);
        if (!response) {
          localStorage.clear();
          this.cookieService.deleteAll('/', null, true);
          this.flag = true;
          this.router.navigate(["/login"]);
          this.globalCurrentUserService.checkLoggedIn.next(false);
        }
        //console.log("Token updated");
        const currentUser = JSON.parse(this.globalCurrentUserService.getCurrentUser());
        const newCookie = { accessToken: response["accessToken"], refreshToken: response["refreshToken"], expiresIn: response["expiresIn"] };
        this.globalCurrentUserService.setCurrentUser(
          // JSON.stringify({accessToken:response["accessToken"], refreshToken:response["refreshToken"], expiresIn:response["expiresIn"], terrId:response["terrId"]})
          JSON.stringify(Object.assign(currentUser, newCookie))
        );
        this.flag = true;
        authReq = req.clone({
          setHeaders: {
            authorization: response["accessToken"]
          }
        })
      }
      // if your getAuthToken() function declared to return an observable then you can use
      // await this.auth.getAuthToken().toPromise()

      // Important: Note the .toPromise()

    }
    return next.handle(authReq).toPromise()
  }
}